import * as c from '../../constants/grades';
import update from 'immutability-helper';

export const defaultState = [];

export const baseGrade = {
  id: 0,
  exerciseCode: '',
  score: 0,
  timeOnTask: 0,
  attempts: 0,
  isComplete: false,
  retakesAllowed: 0,
  updatedAt: null,
};

const mergeGrade = (state, grade) => {
  const index = state.findIndex(
    (item) => item.exerciseCode === grade.exerciseCode
  );

  if (index < 0) {
    return update(state, { $push: [grade] });
  } else {
    return update(state, { [index]: { $merge: grade } });
  }
};

const responses = (state = defaultState, action) => {
  switch (action.type) {
    case c.GRADE_LOAD_GRADEBOOK:
      return action.grades;

    case c.GRADE_SUBMIT_ANSWER_SUCCESS:
      return mergeGrade(state, action.result.grade);

    case c.GRADE_BEGIN_SUCCESS:
    case c.GRADE_FINISH_SUCCESS:
    case c.GRADE_RETAKE_SUCCESS:
    case c.GRADE_MARK_COMPLETE_SUCCESS:
      const {
        id,
        exerciseCode,
        timeOnTask,
        attempts,
        isComplete,
        score,
        retakesAllowed,
      } = action.result;
      return mergeGrade(state, {
        id,
        exerciseCode,
        timeOnTask,
        attempts,
        isComplete,
        score,
        retakesAllowed,
      });

    default:
      return state;
  }
};

export default responses;
